import {Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {AppComponent} from "../../../app.component";
import {MatDialog, MatDialogConfig} from "@angular/material/dialog";
import {DateAdapter} from "@angular/material/core";
import {SharedDataService} from "../../../services/shared-data.service";
import {FS3ValidationResult} from "../../../objects/validationResult";
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {EventApi} from "@fullcalendar/angular";
import {FormatterInput} from "@fullcalendar/common";
import {MatCalendarCellClassFunction, MatDatepickerInputEvent} from "@angular/material/datepicker";
import {
  DAY,
  extractCalendarStep,
  extractDurationFromPackage,
  getFullTwoWeeks, getTimeWindow,
  hoursToSeconds
} from "../../../utils/parseUtils";
import {environment} from "../../../../environments/environment";
import {DialogCanvasComponent} from "../../dialog-canvas/dialog-canvas.component";
import {FS3Notification} from "../../../objects/notification";
import {ListItem} from "../../../objects/listItem";
import {ConfirmationDialogComponent} from "../../confirmation-dialog/confirmation-dialog.component";
import {AppEvent} from "../../../objects/appEvent";
import {MatSlideToggleChange} from "@angular/material/slide-toggle";

@Component({
  selector: 'app-trainer-calendar-event-form',
  templateUrl: './trainer-calendar-event-form.component.html',
  styleUrls: ['./trainer-calendar-event-form.component.css']
})
export class TrainerCalendarEventFormComponent implements OnInit {
  @Input() application: AppComponent;
  @Input() payload: object;
  @Output() success = new EventEmitter<void>();
  @Output() close = new EventEmitter<void>();

  @ViewChild('eventStartInputElem') public eventStartInputElem: ElementRef<HTMLElement>;

  private formValidationMessages = {
    required: 'Value required.',
    user_required: 'Pls pick a user.',
  };
  public validationResult: FS3ValidationResult;
  public componentForm: FormGroup = new FormGroup({});
  public eventStartInput: FormControl = new FormControl('', [Validators.required]);
  private eventStartValue: number;
  public eventHourStart: FormControl = new FormControl('', [Validators.required]);
  public durationControl: FormControl = new FormControl('', [Validators.required]);
  public trainers;
  public allPackages;
  public displayPackages;
  public pickedPackage;
  public trainerPackagesControl: FormControl = new FormControl('', [Validators.required]);
  public trainerMode: boolean = false;
  public toggleTrainerControl: FormControl = new FormControl();
  public trainersControl: FormControl = new FormControl('', [Validators.required]);
  public applyUserServiceChecksControl: FormControl = new FormControl(true);
  public courtIDXControl: FormControl = new FormControl('', [Validators.required]);
  public servicesUsageItemsDescription: string;

  packagesLoaded: boolean = false;
  trainersLoaded: boolean = false;
  state: string = 'edit';
  mode: string = '';
  errMsg: string = '';
  public trainerID: number = 0;
  public item: EventApi;
  public fromDate: Date = ((): Date => {
    let d = new Date();
    d.setTime(Math.floor(d.getTime()/(DAY))*DAY)
    return d;
  })();
  public toDate: Date = getFullTwoWeeks();
  dateFormatter: FormatterInput = {
    month: 'long',
    day: 'numeric',
  }
  dateClass: MatCalendarCellClassFunction<Date> = (cellDate, view) => {
    // Only highligh dates inside the month view.
    if (view === 'month') {
      const cellTime = cellDate.getTime();
      const fromTime = this.fromDate.getTime();
      const toTime = this.toDate.getTime();
      if( (cellTime+DAY) > fromTime && cellTime <= toTime) {
        return 'highlight-date-class'
      }
    }
    return '';
  };
  public calendarIDX = -1;
  public courts: object[] = [];
  public settings: object;
  public hours: string[] = []
  public durations: object[] = [] //displayed package durations

  constructor(public dialog: MatDialog,
              private _adapter: DateAdapter<any>,
              public confirmationDialog: MatDialog,
              private sharedDataService: SharedDataService) { }

  ngOnInit(): void {
    this._adapter.setLocale('uk');
    this.item = this.payload['item'];
    this.trainerID = this.payload['trainerID'];
    this.componentForm.addControl('eventStartInput', this.eventStartInput);
    this.componentForm.addControl('eventHourStart', this.eventHourStart);
    this.eventHourStart.disable(); //loaded after package change
    this.componentForm.addControl('durationControl', this.durationControl);
    this.durationControl.disable(); //loaded after package change
    this.componentForm.addControl('toggleTrainerControl', this.toggleTrainerControl);
    this.componentForm.addControl('trainersControl', this.trainersControl);
    this.componentForm.addControl('trainerPackagesControl', this.trainerPackagesControl);
    this.componentForm.addControl('applyUserServiceChecksControl', this.applyUserServiceChecksControl);
    this.applyUserServiceChecksControl.disable()
    if(this.trainerID) {
      this.trainerMode = this.trainerID ? true : false;
      this.toggleTrainerControl.setValue(true)
      this.toggleTrainerControl.disable()
      this.trainersControl.disable()
    }
    this.componentForm.addControl('courtIDXControl', this.courtIDXControl);
    if(this.item) {
      //todo
    }
    this.loadPackages();
    this.loadTrainers();
  }

  public loadPackages(): void {
    this.state = 'loading';
    this.application.apiService.getPackageDetails(environment['gid'],environment['g_hash'],false)
      .subscribe (
        data => {
          this.packagesLoaded = true;
          if(this.trainersLoaded) this.state = 'edit';
          //todo apply trainerMode
          this.allPackages = data['packages'];
          //this.allPackages = data['packages'];
          this.setDisplayPackages()
        },
        error => {
          this.state = 'error';
          const { exception } = error;
          if (exception && exception.error && exception.error.message) {
            let notification = new FS3Notification();
            notification.type = 'error';
            notification.text = exception.error.message;
            this.sharedDataService.pushNotification(notification);
          }
        }
      )
  }

  public setDisplayPackages(): void {
    let filteredPackages
    if(this.trainerMode) {
      filteredPackages = this.application.apiService.extractPackages({"packages":this.allPackages},true)
    } else {
      filteredPackages = this.application.apiService.extractPackages({"packages":this.allPackages},false,true)
    }
    this.displayPackages = filteredPackages['packages'].filter(trainerPackage => {
      const params = JSON.parse(trainerPackage['params']);
      return params['start_booking'] && trainerPackage['calendarID'] != -1
    })
  }

  public loadTrainers(): void {
    this.state = 'loading';
    this.application.apiService.getGroupTrainers(true)
      .subscribe (
        data => {
          this.trainersLoaded = true;
          if(this.packagesLoaded) this.state = 'edit';
          this.trainers = data.map(listItem => listItem.itemFullData);
          if(this.trainerID) {
            this.trainersControl.setValue(this.trainers.find(trainer => trainer['id'] == this.trainerID))
          }
        },
        error => {
          this.state = 'error';
          const { exception } = error;
          if (exception && exception.error && exception.error.message) {
            let notification = new FS3Notification();
            notification.type = 'error';
            notification.text = exception.error.message;
            this.sharedDataService.pushNotification(notification);
          }
        }
      )
  }

  public packageChange(): void {
    this.displayPackages.forEach(trainerPackage => {
      if(trainerPackage['id'] == this.trainerPackagesControl.value) {
        this.pickedPackage = trainerPackage;
        if(trainerPackage['calendarID'] === 0) { //backward compatibility
          this.calendarIDX = 0;
        } else {
          this.calendarIDX = this.application.account.calendars.findIndex(calendar => calendar['ID'] == trainerPackage['calendarID'])
        }
      }
    })
    this.eventHourStart.enable();
    this.settings = {
      "start":AppComponent.convertHMtoSeconds(this.application.account.calendars[this.calendarIDX]['parsed_params']['start_hour']),
      "end":AppComponent.convertHMtoSeconds(this.application.account.calendars[this.calendarIDX]['parsed_params']['end_hour']),
      "duration":this.application.account.calendars[this.calendarIDX]['parsed_params']['duration']
    };
    let calendarStep = extractCalendarStep(this.settings['duration']);
    this.hours = ((calendarStep,settings): string[] => {
      let hours: string[] = []
      let start: number = settings['start'];
      let hour: number = 0;
      let minutes: number = 0;
      while(start <= settings['end']-settings['duration']) { //last interval window shall be excluded
        hour = Math.floor(start/3600);
        minutes = (start-hour*3600)/60;
        hours.push( ((hour < 10) ? '0'+hour : hour) + ':' + (minutes ? minutes : '00'));
        //start+= settings['duration']/2;
        start+= calendarStep;
      }
      return hours;
    })(calendarStep,this.settings)

    const packageDuration = extractDurationFromPackage(this.pickedPackage,this.application.account.calendars);
    const durationSteppers = (packageDuration > 1200) ? [0.5,1,1.5,2,2.5,3] : [1,2,3,4,5,6]; //no better ideas for now
    this.durations = [];
    durationSteppers.forEach(step => {
      let stepDuration = packageDuration*step;
      let duration = {'label':getTimeWindow(stepDuration)+' ('+step+'x)','duration':stepDuration,'qty':step};
      this.durations.push(duration);
      if(packageDuration == stepDuration) {
        this.durationControl.setValue(duration);
      }
    })
    this.durationControl.enable();
    this.courts = this.application.account.calendars[this.calendarIDX]['parsed_params']['columns'];
    if(!this.courtIDXControl.value) {
      //this.courtIDControl.setValue(this.courts[0]['id'])
      this.courtIDXControl.setValue(0)
    }
    this.showServicesUsage();
  }
  public durationChange() {
    this.showServicesUsage()
  }

  public dateInputClick(event,picker): void {
    event.currentTarget.blur()
    event.stopImmediatePropagation();
    picker.open();
  }

  dateChangeEvent(event: MatDatepickerInputEvent<Date>) {
    const cellTime = event.value.getTime();
    const fromTime = this.fromDate.getTime();
    const toTime = this.toDate.getTime();
    if( (cellTime+DAY) <= fromTime) {
      this.eventStartInput.setValue(this.fromDate);
      event.value = this.fromDate;
    }
    if( cellTime > toTime) {
      this.eventStartInput.setValue(this.toDate);
      event.value = this.toDate;
    }

    event.targetElement['value'] = this.payload['calendarApi'].formatDate(event.value,this.dateFormatter);
    this.eventStartValue = event.value.getTime()
  }

  public onNoClick(): void {
    //this.dialogRef.close({ isConfirmed: false });
    this.close.emit()
  }

  public handleSubmit(event: Event | void = null): boolean {
    if (event) {
      event.stopPropagation();
    }

    this.validationResult = null;
    [this.trainersControl,this.trainerPackagesControl,this.eventStartInput,this.eventHourStart,this.durationControl].forEach(elem => {
      if (!elem.valid) {
        elem.markAsTouched()
        if(!elem.errors) return;
        const errorKey = Object.keys(elem.errors)[0]; // get error key from input errors
        this.validationResult = {
          isValid: false,
          message: this.formValidationMessages[errorKey]
        };
      }
    });

    if (!this.profile) {
      this.validationResult = {
        isValid: false,
        message: this.formValidationMessages['user_required']
      };
    }

    if (this.validationResult) {
      return false;
    }

    this.saveEvent();
    return false
  }

  private saveEvent(deleteItem: boolean = false) {
    let configToSave;
    let actionType = this.trainerMode ? 'club_event' : 'profile_event';
    let eventType = this.trainerMode ? 'trainer_booking_add' : 'booking_add';
    let eventLabel = this.trainerMode ? 'Add training' : 'Add booking';
    if(!deleteItem) {
      configToSave = {
        calendar_id: this.application.account.calendars[this.calendarIDX]['ID'],
        trainer_id: this.payload['trainerID'],
        user_id: this.profile.itemFullData['id'],
        label: eventLabel,
        event_start_day: this.eventStartValue/1000,
        event_hours: this.eventHourStart.value,
        event_seconds: hoursToSeconds(this.eventHourStart.value),
        package_id: this.trainerPackagesControl.value,
        qty: this.durationControl.value['qty'], //used on server on getPotentialBookingPurchaseData
        duration: this.durationControl.value['duration'], //for debug
        credit_order: !this.applyUserServiceChecksControl.value,
        court_object_idx: this.courtIDXControl.value
      }
    } else { //todo
      configToSave = {
        delete_item: true,
        group_key: this.item.extendedProps['group_key'],
      }
    }
    // console.log('configToSave',configToSave)
    // return;
    this.state = 'loading';
    this.application.apiService
      .updateEventItem(
        environment['gid'],environment['g_hash'], '',
        this.payload['item'] ? this.payload['item']['id'] : null,
        actionType,eventType,configToSave)
      .subscribe(
        res => {
          let notification = new FS3Notification();
          notification.type = 'success';
          notification.text = AppComponent.getLabel('schedule_updated');
          this.sharedDataService.pushNotification(notification);
          let appEvent = new AppEvent(AppEvent.SCHEDULE_UPDATED, {});
          this.sharedDataService.pushAppEvent(appEvent)
          // todo - maybe append new item to list
          // if(!this.payload['item']) { //append new item to list
          //   let appEvent = new AppEvent(AppEvent.SCHEDULE_ADDED, {bookingEvents: this.application.apiService.extractBookingData(res)});
          //   this.sharedDataService.pushAppEvent(appEvent)
          // } else {
          //   let appEvent = new AppEvent(AppEvent.SCHEDULE_UPDATED, {});
          //   this.sharedDataService.pushAppEvent(appEvent)
          // }
          this.success.emit()
        },
        error => {
          const { exception } = error;
          const errMsg = error['errMsg'] ? error['errMsg'] : (
            (exception && exception.error && exception.error.message) ? exception.error.message : 'Error'
          );
          let notification = new FS3Notification();
          notification.type = 'error';
          notification.text = errMsg;
          this.sharedDataService.pushNotification(notification);
          this.state = 'edit'
          this.validationResult = {
            isValid: false,
            message: errMsg
          };
        }
      )
  }

  public deleteEvent(): void {
    // this.close.emit()
    const dialogRef = this.dialog.open(DialogCanvasComponent, {
      height: 'auto',
      data: {
        application: this,
        state: 'schedule-event-delete',
        payload: {
          //folderUUID: this.urlAfterRedirects.split('/')[3],
        }
      }
    } as MatDialogConfig);
    dialogRef.addPanelClass('common-dialog');
    dialogRef.addPanelClass('common-dialog-medium-form');
    dialogRef.afterOpened().subscribe(() => {
      (dialogRef.componentInstance as DialogCanvasComponent).isOpened = true;
    })
    dialogRef.afterClosed()
      .subscribe((dialogPayload) => {
        if(dialogPayload) {
          //todo
          //this.updateSchedule(true,dialogPayload['duplicateChanges'])
        }
      })
  }

  public profile: ListItem
  public pickList: ListItem[]
  public pickItemsLoading = false;
  public userPick(): void {
    this.pickList = [];
    this.pickItemsLoading = true;
    this.application.apiService.getClients('', AppComponent.user.magic_key)
      .subscribe(
        items => this.gotClients(items),
        error => this.handleItemsError(error))
  }
  public gotClients(items): void {
    items.map(item => {
      if(item['itemFullData']['id'] == 123) { //self skip
        return;
      }
      this.pickList.push(item);
    });
    this.pickItemsLoading = false;
    this.pickUserPopup();
  }
  public handleItemsError(error): void {
    this.pickItemsLoading = false;
    this.state = 'error';
    this.errMsg = error.errMsg;
  }
  public pickUserPopup(): void {
    let payloadUsers = this.pickList;
    const dialogRef = this.dialog.open(DialogCanvasComponent, {
      minWidth: this.application.layoutMatches['isHandsetDefaultLayout'] ? '95%' : '65%',
      height: 'auto',
      data: {
        application: this.application,
        state: 'user-pick',
        payload: {users: payloadUsers},
      }
    } as MatDialogConfig);
    dialogRef.addPanelClass('common-dialog');
    dialogRef.addPanelClass('common-dialog-medium-form');
    dialogRef.afterOpened().subscribe(() => {
      (dialogRef.componentInstance as DialogCanvasComponent).isOpened = true;
    })
    dialogRef.afterClosed()
      .subscribe((dialogPayload) => {
        if(dialogPayload) {
          //console.log('dialogPayload',dialogPayload)
          this.profile = dialogPayload['user'];
          this.showServicesUsage();
        }
      })
  }

  public deleteUser() {
    const dialogRef = this.confirmationDialog.open(ConfirmationDialogComponent, {
      width: '22vw',
      height: '18vh',
      autoFocus: false,
      panelClass: 'common-dialog',
      data: {
        title: AppComponent.getLabel('delete_confirmation_popup_title'),
        message: AppComponent.getLabel('delete_confirmation_popup_description'),
        cancelLabel: AppComponent.getLabel('close'),
        actionLabel: AppComponent.getLabel('confirm'),
      }
    });
    dialogRef.afterClosed()
      .subscribe((result) => {
        if (result && result.isConfirmed) {
          dialogRef.close()
          this.profile = null;
        }
      })
  }

  public switchTrainerMode(): void {
    this.trainerMode = this.toggleTrainerControl.value
    this.setDisplayPackages()
  }

  public showServicesUsage(): void {
    if(!this.profile) return;
    if(!this.trainerPackagesControl.value) return;
    if(!this.durationControl.value) return;
    this.applyUserServiceChecksControl.enable();
    let configToCheck;
    configToCheck = {
      calendar_id: this.application.account.calendars[this.calendarIDX]['ID'],
      trainer_id: this.payload['trainerID'],
      user_id: this.profile.itemFullData['id'],
      label: 'Add training',
      event_start_day: this.eventStartValue/1000,
      event_hours: this.eventHourStart.value,
      event_seconds: hoursToSeconds(this.eventHourStart.value),
      package_id: this.trainerPackagesControl.value,
      qty: this.durationControl.value['qty'], //used on server on getPotentialBookingPurchaseData
      duration: this.durationControl.value['duration'], //for debug
      credit_order: !this.applyUserServiceChecksControl.value,
      court_object_idx: this.courtIDXControl.value,
    }
    this.mode = 'check';
    this.application.apiService
      .packageUsageCheck(
        environment['gid'],environment['g_hash'], '',
        this.payload['item'] ? this.payload['item']['id'] : null,
        'club_event','trainer_booking_add',configToCheck)
      .subscribe(
        res => {
          this.servicesUsageItemsDescription = res['servicesUsageItemsDescription'].join('<br>');
        },
        error => {
          const { exception } = error;
          const errMsg = error['errMsg'] ? error['errMsg'] : (
            (exception && exception.error && exception.error.message) ? exception.error.message : 'Error'
          );
          let notification = new FS3Notification();
          notification.type = 'error';
          notification.text = errMsg;
          this.sharedDataService.pushNotification(notification);
        }
      )
  }

}
